import React from 'react';

import InvestigationsWidget from 'security-app/components/Investigations/plugin/SearchWidgets/logic/InvestigationsWidget';
import PerspectivesProvider from 'components/perspectives/contexts/PerspectivesProvider';

const WidgetProvidersByType = ({ type, children = undefined }: React.PropsWithChildren<{ type: string }>) => {
  if (type === InvestigationsWidget.type) {
    return <PerspectivesProvider>{children}</PerspectivesProvider>;
  }

  return <>{children}</>;
};

export default WidgetProvidersByType;
